import { LitElement, html, svg } from 'lit';

export class IconBookmark24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Bokmerke</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 1h18a1 1 0 0 1 1 1v21l-9.4-7.05a1 1 0 0 0-1.2 0L2 23V2a1 1 0 0 1 1-1Z"></path></svg>`; }
}
if (!customElements.get('f-icon-bookmark24', IconBookmark24)) {
  customElements.define('f-icon-bookmark24', IconBookmark24);
}